import { Badge, HStack } from '@chakra-ui/react';

type PercentSelectProps = {
  list: number[];
  // eslint-disable-next-line no-unused-vars
  onPercent: (item: number) => void;
};

const PercentSelect: React.FC<PercentSelectProps> = ({
  list,
  onPercent,
}: PercentSelectProps) => {
  return (
    <HStack flexWrap="wrap" gap={2}>
      {list.map((item) => (
        <Badge
          key={item}
          py={2}
          px={3}
          minW="3.5rem"
          textAlign="center"
          borderRadius="md"
          fontSize="sm"
          fontWeight="medium"
          cursor="pointer"
          borderWidth="1px"
          borderColor="rgba(255,255,255,0.1)"
          bg="rgba(255,255,255,0.05)"
          color="body"
          transition="background 0.15s ease, border-color 0.15s ease, color 0.15s ease"
          _hover={{
            bg: 'rgba(62, 207, 142, 0.12)',
            borderColor: 'rgba(62, 207, 142, 0.35)',
            color: 'primary',
          }}
          onClick={() => onPercent(item)}
        >
          {item}%
        </Badge>
      ))}
    </HStack>
  );
};

export default PercentSelect;
